export type CountryCode =
  | "AC"
  | "AD"
  | "AE"
  | "AF"
  | "AG"
  | "AI"
  | "AL"
  | "AM"
  | "AO"
  | "AR"
  | "AS"
  | "AT"
  | "AU"
  | "AW"
  | "AX"
  | "AZ"
  | "BA"
  | "BB"
  | "BD"
  | "BE"
  | "BF"
  | "BG"
  | "BH"
  | "BI"
  | "BJ"
  | "BL"
  | "BM"
  | "BN"
  | "BO"
  | "BQ"
  | "BR"
  | "BS"
  | "BT"
  | "BW"
  | "BY"
  | "BZ"
  | "CA"
  | "CC"
  | "CD"
  | "CF"
  | "CG"
  | "CH"
  | "CI"
  | "CK"
  | "CL"
  | "CM"
  | "CN"
  | "CO"
  | "CR"
  | "CU"
  | "CV"
  | "CW"
  | "CX"
  | "CY"
  | "CZ"
  | "DE"
  | "DJ"
  | "DK"
  | "DM"
  | "DO"
  | "DZ"
  | "EC"
  | "EE"
  | "EG"
  | "EH"
  | "ER"
  | "ES"
  | "ET"
  | "FI"
  | "FJ"
  | "FK"
  | "FM"
  | "FO"
  | "FR"
  | "GA"
  | "GB"
  | "GD"
  | "GE"
  | "GF"
  | "GG"
  | "GH"
  | "GI"
  | "GL"
  | "GM"
  | "GN"
  | "GP"
  | "GQ"
  | "GR"
  | "GT"
  | "GU"
  | "GW"
  | "GY"
  | "HK"
  | "HN"
  | "HR"
  | "HT"
  | "HU"
  | "ID"
  | "IE"
  | "IL"
  | "IM"
  | "IN"
  | "IO"
  | "IQ"
  | "IR"
  | "IS"
  | "IT"
  | "JE"
  | "JM"
  | "JO"
  | "JP"
  | "KE"
  | "KG"
  | "KH"
  | "KI"
  | "KM"
  | "KN"
  | "KP"
  | "KR"
  | "KW"
  | "KY"
  | "KZ"
  | "LA"
  | "LB"
  | "LC"
  | "LI"
  | "LK"
  | "LR"
  | "LS"
  | "LT"
  | "LU"
  | "LV"
  | "LY"
  | "MA"
  | "MC"
  | "MD"
  | "ME"
  | "MF"
  | "MG"
  | "MH"
  | "MK"
  | "ML"
  | "MM"
  | "MN"
  | "MO"
  | "MP"
  | "MQ"
  | "MR"
  | "MS"
  | "MT"
  | "MU"
  | "MV"
  | "MW"
  | "MX"
  | "MY"
  | "MZ"
  | "NA"
  | "NC"
  | "NE"
  | "NF"
  | "NG"
  | "NI"
  | "NL"
  | "NO"
  | "NP"
  | "NR"
  | "NU"
  | "NZ"
  | "OM"
  | "PA"
  | "PE"
  | "PF"
  | "PG"
  | "PH"
  | "PK"
  | "PL"
  | "PM"
  | "PR"
  | "PS"
  | "PT"
  | "PW"
  | "PY"
  | "QA"
  | "RE"
  | "RO"
  | "RS"
  | "RU"
  | "RW"
  | "SA"
  | "SB"
  | "SC"
  | "SD"
  | "SE"
  | "SG"
  | "SH"
  | "SI"
  | "SJ"
  | "SK"
  | "SL"
  | "SM"
  | "SN"
  | "SO"
  | "SR"
  | "SS"
  | "ST"
  | "SV"
  | "SX"
  | "SY"
  | "SZ"
  | "TA"
  | "TC"
  | "TD"
  | "TG"
  | "TH"
  | "TJ"
  | "TK"
  | "TL"
  | "TM"
  | "TN"
  | "TO"
  | "TR"
  | "TT"
  | "TV"
  | "TW"
  | "TZ"
  | "UA"
  | "UG"
  | "US"
  | "UY"
  | "UZ"
  | "VA"
  | "VC"
  | "VE"
  | "VG"
  | "VI"
  | "VN"
  | "VU"
  | "WF"
  | "WS"
  | "XK"
  | "YE"
  | "YT"
  | "ZA"
  | "ZM"
  | "ZW";

export interface CountryData {
  countryCallingCode: string;
  countryCode: CountryCode;
  countryNameEn: string;
}

const BLACK_LISTED_COUNTRIES = new Set([
  "AG",
  "AI",
  "AS",
  "GD",
  "GU",
  "KN",
  "LC",
  "MS",
  "SX",
  "VC",
  "VG",
  "VI",
  "DO",
  "BS",
  "KY",
  "MP",
  "TC",
  "UM",
  "BB",
  "BM",
]);

const PRIORITY_COUNTRIES: CountryCode[] = ["IN", "US", "BD", "SG", "MY", "AE"];

const ALL_COUNTRY_CODES: CountryData[] = [
  {
    countryCode: "AC",
    countryNameEn: "Ascension Island",
    countryCallingCode: "247",
  },
  { countryCode: "AD", countryNameEn: "Andorra", countryCallingCode: "376" },
  {
    countryCode: "AE",
    countryNameEn: "United Arab Emirates",
    countryCallingCode: "971",
  },
  { countryCode: "AF", countryNameEn: "Afghanistan", countryCallingCode: "93" },
  {
    countryCode: "AG",
    countryNameEn: "Antigua and Barbuda",
    countryCallingCode: "1268",
  },
  { countryCode: "AI", countryNameEn: "Anguilla", countryCallingCode: "1264" },
  { countryCode: "AL", countryNameEn: "Albania", countryCallingCode: "355" },
  { countryCode: "AM", countryNameEn: "Armenia", countryCallingCode: "374" },
  { countryCode: "AO", countryNameEn: "Angola", countryCallingCode: "244" },
  { countryCode: "AR", countryNameEn: "Argentina", countryCallingCode: "54" },
  {
    countryCode: "AS",
    countryNameEn: "American Samoa",
    countryCallingCode: "1684",
  },
  { countryCode: "AT", countryNameEn: "Austria", countryCallingCode: "43" },
  { countryCode: "AU", countryNameEn: "Australia", countryCallingCode: "61" },
  { countryCode: "AW", countryNameEn: "Aruba", countryCallingCode: "297" },
  {
    countryCode: "AX",
    countryNameEn: "Åland Islands",
    countryCallingCode: "358",
  },
  { countryCode: "AZ", countryNameEn: "Azerbaijan", countryCallingCode: "994" },
  {
    countryCode: "BA",
    countryNameEn: "Bosnia and Herzegovina",
    countryCallingCode: "387",
  },
  { countryCode: "BB", countryNameEn: "Barbados", countryCallingCode: "1246" },
  { countryCode: "BD", countryNameEn: "Bangladesh", countryCallingCode: "880" },
  { countryCode: "BE", countryNameEn: "Belgium", countryCallingCode: "32" },
  {
    countryCode: "BF",
    countryNameEn: "Burkina Faso",
    countryCallingCode: "226",
  },
  { countryCode: "BG", countryNameEn: "Bulgaria", countryCallingCode: "359" },
  { countryCode: "BH", countryNameEn: "Bahrain", countryCallingCode: "973" },
  { countryCode: "BI", countryNameEn: "Burundi", countryCallingCode: "257" },
  { countryCode: "BJ", countryNameEn: "Benin", countryCallingCode: "229" },
  {
    countryCode: "BL",
    countryNameEn: "Saint Barthélemy",
    countryCallingCode: "590",
  },
  { countryCode: "BM", countryNameEn: "Bermuda", countryCallingCode: "1441" },
  { countryCode: "BN", countryNameEn: "Brunei", countryCallingCode: "673" },
  { countryCode: "BO", countryNameEn: "Bolivia", countryCallingCode: "591" },
  {
    countryCode: "BQ",
    countryNameEn: "Caribbean Netherlands",
    countryCallingCode: "599",
  },
  { countryCode: "BR", countryNameEn: "Brazil", countryCallingCode: "55" },
  { countryCode: "BS", countryNameEn: "Bahamas", countryCallingCode: "1242" },
  { countryCode: "BT", countryNameEn: "Bhutan", countryCallingCode: "975" },
  { countryCode: "BW", countryNameEn: "Botswana", countryCallingCode: "267" },
  { countryCode: "BY", countryNameEn: "Belarus", countryCallingCode: "375" },
  { countryCode: "BZ", countryNameEn: "Belize", countryCallingCode: "501" },
  { countryCode: "CA", countryNameEn: "Canada", countryCallingCode: "1" },
  {
    countryCode: "CC",
    countryNameEn: "Cocos (Keeling) Islands",
    countryCallingCode: "61",
  },
  {
    countryCode: "CD",
    countryNameEn: "Congo (DRC)",
    countryCallingCode: "243",
  },
  {
    countryCode: "CF",
    countryNameEn: "Central African Republic",
    countryCallingCode: "236",
  },
  {
    countryCode: "CG",
    countryNameEn: "Congo (Republic)",
    countryCallingCode: "242",
  },
  { countryCode: "CH", countryNameEn: "Switzerland", countryCallingCode: "41" },
  {
    countryCode: "CI",
    countryNameEn: "Côte d'Ivoire",
    countryCallingCode: "225",
  },
  {
    countryCode: "CK",
    countryNameEn: "Cook Islands",
    countryCallingCode: "682",
  },
  { countryCode: "CL", countryNameEn: "Chile", countryCallingCode: "56" },
  { countryCode: "CM", countryNameEn: "Cameroon", countryCallingCode: "237" },
  { countryCode: "CN", countryNameEn: "China", countryCallingCode: "86" },
  { countryCode: "CO", countryNameEn: "Colombia", countryCallingCode: "57" },
  { countryCode: "CR", countryNameEn: "Costa Rica", countryCallingCode: "506" },
  { countryCode: "CU", countryNameEn: "Cuba", countryCallingCode: "53" },
  { countryCode: "CV", countryNameEn: "Cape Verde", countryCallingCode: "238" },
  { countryCode: "CW", countryNameEn: "Curaçao", countryCallingCode: "599" },
  {
    countryCode: "CX",
    countryNameEn: "Christmas Island",
    countryCallingCode: "61",
  },
  { countryCode: "CY", countryNameEn: "Cyprus", countryCallingCode: "357" },
  {
    countryCode: "CZ",
    countryNameEn: "Czech Republic",
    countryCallingCode: "420",
  },
  { countryCode: "DE", countryNameEn: "Germany", countryCallingCode: "49" },
  { countryCode: "DJ", countryNameEn: "Djibouti", countryCallingCode: "253" },
  { countryCode: "DK", countryNameEn: "Denmark", countryCallingCode: "45" },
  { countryCode: "DM", countryNameEn: "Dominica", countryCallingCode: "1767" },
  {
    countryCode: "DO",
    countryNameEn: "Dominican Republic",
    countryCallingCode: "1809",
  },
  { countryCode: "DZ", countryNameEn: "Algeria", countryCallingCode: "213" },
  { countryCode: "EC", countryNameEn: "Ecuador", countryCallingCode: "593" },
  { countryCode: "EE", countryNameEn: "Estonia", countryCallingCode: "372" },
  { countryCode: "EG", countryNameEn: "Egypt", countryCallingCode: "20" },
  {
    countryCode: "EH",
    countryNameEn: "Western Sahara",
    countryCallingCode: "212",
  },
  { countryCode: "ER", countryNameEn: "Eritrea", countryCallingCode: "291" },
  { countryCode: "ES", countryNameEn: "Spain", countryCallingCode: "34" },
  { countryCode: "ET", countryNameEn: "Ethiopia", countryCallingCode: "251" },
  { countryCode: "FI", countryNameEn: "Finland", countryCallingCode: "358" },
  { countryCode: "FJ", countryNameEn: "Fiji", countryCallingCode: "679" },
  {
    countryCode: "FK",
    countryNameEn: "Falkland Islands",
    countryCallingCode: "500",
  },
  { countryCode: "FM", countryNameEn: "Micronesia", countryCallingCode: "691" },
  {
    countryCode: "FO",
    countryNameEn: "Faroe Islands",
    countryCallingCode: "298",
  },
  { countryCode: "FR", countryNameEn: "France", countryCallingCode: "33" },
  { countryCode: "GA", countryNameEn: "Gabon", countryCallingCode: "241" },
  {
    countryCode: "GB",
    countryNameEn: "United Kingdom",
    countryCallingCode: "44",
  },
  { countryCode: "GD", countryNameEn: "Grenada", countryCallingCode: "1473" },
  { countryCode: "GE", countryNameEn: "Georgia", countryCallingCode: "995" },
  {
    countryCode: "GF",
    countryNameEn: "French Guiana",
    countryCallingCode: "594",
  },
  { countryCode: "GG", countryNameEn: "Guernsey", countryCallingCode: "44" },
  { countryCode: "GH", countryNameEn: "Ghana", countryCallingCode: "233" },
  { countryCode: "GI", countryNameEn: "Gibraltar", countryCallingCode: "350" },
  { countryCode: "GL", countryNameEn: "Greenland", countryCallingCode: "299" },
  { countryCode: "GM", countryNameEn: "Gambia", countryCallingCode: "220" },
  { countryCode: "GN", countryNameEn: "Guinea", countryCallingCode: "224" },
  { countryCode: "GP", countryNameEn: "Guadeloupe", countryCallingCode: "590" },
  {
    countryCode: "GQ",
    countryNameEn: "Equatorial Guinea",
    countryCallingCode: "240",
  },
  { countryCode: "GR", countryNameEn: "Greece", countryCallingCode: "30" },
  { countryCode: "GT", countryNameEn: "Guatemala", countryCallingCode: "502" },
  { countryCode: "GU", countryNameEn: "Guam", countryCallingCode: "1671" },
  {
    countryCode: "GW",
    countryNameEn: "Guinea-Bissau",
    countryCallingCode: "245",
  },
  { countryCode: "GY", countryNameEn: "Guyana", countryCallingCode: "592" },
  { countryCode: "HK", countryNameEn: "Hong Kong", countryCallingCode: "852" },
  { countryCode: "HN", countryNameEn: "Honduras", countryCallingCode: "504" },
  { countryCode: "HR", countryNameEn: "Croatia", countryCallingCode: "385" },
  { countryCode: "HT", countryNameEn: "Haiti", countryCallingCode: "509" },
  { countryCode: "HU", countryNameEn: "Hungary", countryCallingCode: "36" },
  { countryCode: "ID", countryNameEn: "Indonesia", countryCallingCode: "62" },
  { countryCode: "IE", countryNameEn: "Ireland", countryCallingCode: "353" },
  { countryCode: "IL", countryNameEn: "Israel", countryCallingCode: "972" },
  { countryCode: "IM", countryNameEn: "Isle of Man", countryCallingCode: "44" },
  { countryCode: "IN", countryNameEn: "India", countryCallingCode: "91" },
  {
    countryCode: "IO",
    countryNameEn: "British Indian Ocean Territory",
    countryCallingCode: "246",
  },
  { countryCode: "IQ", countryNameEn: "Iraq", countryCallingCode: "964" },
  { countryCode: "IR", countryNameEn: "Iran", countryCallingCode: "98" },
  { countryCode: "IS", countryNameEn: "Iceland", countryCallingCode: "354" },
  { countryCode: "IT", countryNameEn: "Italy", countryCallingCode: "39" },
  { countryCode: "JE", countryNameEn: "Jersey", countryCallingCode: "44" },
  { countryCode: "JM", countryNameEn: "Jamaica", countryCallingCode: "1876" },
  { countryCode: "JO", countryNameEn: "Jordan", countryCallingCode: "962" },
  { countryCode: "JP", countryNameEn: "Japan", countryCallingCode: "81" },
  { countryCode: "KE", countryNameEn: "Kenya", countryCallingCode: "254" },
  { countryCode: "KG", countryNameEn: "Kyrgyzstan", countryCallingCode: "996" },
  { countryCode: "KH", countryNameEn: "Cambodia", countryCallingCode: "855" },
  { countryCode: "KI", countryNameEn: "Kiribati", countryCallingCode: "686" },
  { countryCode: "KM", countryNameEn: "Comoros", countryCallingCode: "269" },
  {
    countryCode: "KN",
    countryNameEn: "Saint Kitts and Nevis",
    countryCallingCode: "1869",
  },
  {
    countryCode: "KP",
    countryNameEn: "North Korea",
    countryCallingCode: "850",
  },
  { countryCode: "KR", countryNameEn: "South Korea", countryCallingCode: "82" },
  { countryCode: "KW", countryNameEn: "Kuwait", countryCallingCode: "965" },
  {
    countryCode: "KY",
    countryNameEn: "Cayman Islands",
    countryCallingCode: "1345",
  },
  { countryCode: "KZ", countryNameEn: "Kazakhstan", countryCallingCode: "7" },
  { countryCode: "LA", countryNameEn: "Laos", countryCallingCode: "856" },
  { countryCode: "LB", countryNameEn: "Lebanon", countryCallingCode: "961" },
  {
    countryCode: "LC",
    countryNameEn: "Saint Lucia",
    countryCallingCode: "1758",
  },
  {
    countryCode: "LI",
    countryNameEn: "Liechtenstein",
    countryCallingCode: "423",
  },
  { countryCode: "LK", countryNameEn: "Sri Lanka", countryCallingCode: "94" },
  { countryCode: "LR", countryNameEn: "Liberia", countryCallingCode: "231" },
  { countryCode: "LS", countryNameEn: "Lesotho", countryCallingCode: "266" },
  { countryCode: "LT", countryNameEn: "Lithuania", countryCallingCode: "370" },
  { countryCode: "LU", countryNameEn: "Luxembourg", countryCallingCode: "352" },
  { countryCode: "LV", countryNameEn: "Latvia", countryCallingCode: "371" },
  { countryCode: "LY", countryNameEn: "Libya", countryCallingCode: "218" },
  { countryCode: "MA", countryNameEn: "Morocco", countryCallingCode: "212" },
  { countryCode: "MC", countryNameEn: "Monaco", countryCallingCode: "377" },
  { countryCode: "MD", countryNameEn: "Moldova", countryCallingCode: "373" },
  { countryCode: "ME", countryNameEn: "Montenegro", countryCallingCode: "382" },
  {
    countryCode: "MF",
    countryNameEn: "Saint Martin",
    countryCallingCode: "590",
  },
  { countryCode: "MG", countryNameEn: "Madagascar", countryCallingCode: "261" },
  {
    countryCode: "MH",
    countryNameEn: "Marshall Islands",
    countryCallingCode: "692",
  },
  {
    countryCode: "MK",
    countryNameEn: "North Macedonia",
    countryCallingCode: "389",
  },
  { countryCode: "ML", countryNameEn: "Mali", countryCallingCode: "223" },
  { countryCode: "MM", countryNameEn: "Myanmar", countryCallingCode: "95" },
  { countryCode: "MN", countryNameEn: "Mongolia", countryCallingCode: "976" },
  { countryCode: "MO", countryNameEn: "Macau", countryCallingCode: "853" },
  {
    countryCode: "MP",
    countryNameEn: "Northern Mariana Islands",
    countryCallingCode: "1670",
  },
  { countryCode: "MQ", countryNameEn: "Martinique", countryCallingCode: "596" },
  { countryCode: "MR", countryNameEn: "Mauritania", countryCallingCode: "222" },
  {
    countryCode: "MS",
    countryNameEn: "Montserrat",
    countryCallingCode: "1664",
  },
  { countryCode: "MT", countryNameEn: "Malta", countryCallingCode: "356" },
  { countryCode: "MU", countryNameEn: "Mauritius", countryCallingCode: "230" },
  { countryCode: "MV", countryNameEn: "Maldives", countryCallingCode: "960" },
  { countryCode: "MW", countryNameEn: "Malawi", countryCallingCode: "265" },
  { countryCode: "MX", countryNameEn: "Mexico", countryCallingCode: "52" },
  { countryCode: "MY", countryNameEn: "Malaysia", countryCallingCode: "60" },
  { countryCode: "MZ", countryNameEn: "Mozambique", countryCallingCode: "258" },
  { countryCode: "NA", countryNameEn: "Namibia", countryCallingCode: "264" },
  {
    countryCode: "NC",
    countryNameEn: "New Caledonia",
    countryCallingCode: "687",
  },
  { countryCode: "NE", countryNameEn: "Niger", countryCallingCode: "227" },
  {
    countryCode: "NF",
    countryNameEn: "Norfolk Island",
    countryCallingCode: "672",
  },
  { countryCode: "NG", countryNameEn: "Nigeria", countryCallingCode: "234" },
  { countryCode: "NI", countryNameEn: "Nicaragua", countryCallingCode: "505" },
  { countryCode: "NL", countryNameEn: "Netherlands", countryCallingCode: "31" },
  { countryCode: "NO", countryNameEn: "Norway", countryCallingCode: "47" },
  { countryCode: "NP", countryNameEn: "Nepal", countryCallingCode: "977" },
  { countryCode: "NR", countryNameEn: "Nauru", countryCallingCode: "674" },
  { countryCode: "NU", countryNameEn: "Niue", countryCallingCode: "683" },
  { countryCode: "NZ", countryNameEn: "New Zealand", countryCallingCode: "64" },
  { countryCode: "OM", countryNameEn: "Oman", countryCallingCode: "968" },
  { countryCode: "PA", countryNameEn: "Panama", countryCallingCode: "507" },
  { countryCode: "PE", countryNameEn: "Peru", countryCallingCode: "51" },
  {
    countryCode: "PF",
    countryNameEn: "French Polynesia",
    countryCallingCode: "689",
  },
  {
    countryCode: "PG",
    countryNameEn: "Papua New Guinea",
    countryCallingCode: "675",
  },
  { countryCode: "PH", countryNameEn: "Philippines", countryCallingCode: "63" },
  { countryCode: "PK", countryNameEn: "Pakistan", countryCallingCode: "92" },
  { countryCode: "PL", countryNameEn: "Poland", countryCallingCode: "48" },
  {
    countryCode: "PM",
    countryNameEn: "Saint Pierre and Miquelon",
    countryCallingCode: "508",
  },
  { countryCode: "PR", countryNameEn: "Puerto Rico", countryCallingCode: "1" },
  { countryCode: "PS", countryNameEn: "Palestine", countryCallingCode: "970" },
  { countryCode: "PT", countryNameEn: "Portugal", countryCallingCode: "351" },
  { countryCode: "PW", countryNameEn: "Palau", countryCallingCode: "680" },
  { countryCode: "PY", countryNameEn: "Paraguay", countryCallingCode: "595" },
  { countryCode: "QA", countryNameEn: "Qatar", countryCallingCode: "974" },
  { countryCode: "RE", countryNameEn: "Réunion", countryCallingCode: "262" },
  { countryCode: "RO", countryNameEn: "Romania", countryCallingCode: "40" },
  { countryCode: "RS", countryNameEn: "Serbia", countryCallingCode: "381" },
  { countryCode: "RU", countryNameEn: "Russia", countryCallingCode: "7" },
  { countryCode: "RW", countryNameEn: "Rwanda", countryCallingCode: "250" },
  {
    countryCode: "SA",
    countryNameEn: "Saudi Arabia",
    countryCallingCode: "966",
  },
  {
    countryCode: "SB",
    countryNameEn: "Solomon Islands",
    countryCallingCode: "677",
  },
  { countryCode: "SC", countryNameEn: "Seychelles", countryCallingCode: "248" },
  { countryCode: "SD", countryNameEn: "Sudan", countryCallingCode: "249" },
  { countryCode: "SE", countryNameEn: "Sweden", countryCallingCode: "46" },
  { countryCode: "SG", countryNameEn: "Singapore", countryCallingCode: "65" },
  {
    countryCode: "SH",
    countryNameEn: "Saint Helena",
    countryCallingCode: "290",
  },
  { countryCode: "SI", countryNameEn: "Slovenia", countryCallingCode: "386" },
  {
    countryCode: "SJ",
    countryNameEn: "Svalbard and Jan Mayen",
    countryCallingCode: "47",
  },
  { countryCode: "SK", countryNameEn: "Slovakia", countryCallingCode: "421" },
  {
    countryCode: "SL",
    countryNameEn: "Sierra Leone",
    countryCallingCode: "232",
  },
  { countryCode: "SM", countryNameEn: "San Marino", countryCallingCode: "378" },
  { countryCode: "SN", countryNameEn: "Senegal", countryCallingCode: "221" },
  { countryCode: "SO", countryNameEn: "Somalia", countryCallingCode: "252" },
  { countryCode: "SR", countryNameEn: "Suriname", countryCallingCode: "597" },
  {
    countryCode: "SS",
    countryNameEn: "South Sudan",
    countryCallingCode: "211",
  },
  {
    countryCode: "ST",
    countryNameEn: "São Tomé and Príncipe",
    countryCallingCode: "239",
  },
  {
    countryCode: "SV",
    countryNameEn: "El Salvador",
    countryCallingCode: "503",
  },
  {
    countryCode: "SX",
    countryNameEn: "Sint Maarten",
    countryCallingCode: "1721",
  },
  { countryCode: "SY", countryNameEn: "Syria", countryCallingCode: "963" },
  { countryCode: "SZ", countryNameEn: "Eswatini", countryCallingCode: "268" },
  {
    countryCode: "TA",
    countryNameEn: "Tristan da Cunha",
    countryCallingCode: "290",
  },
  {
    countryCode: "TC",
    countryNameEn: "Turks and Caicos Islands",
    countryCallingCode: "1649",
  },
  { countryCode: "TD", countryNameEn: "Chad", countryCallingCode: "235" },
  { countryCode: "TG", countryNameEn: "Togo", countryCallingCode: "228" },
  { countryCode: "TH", countryNameEn: "Thailand", countryCallingCode: "66" },
  { countryCode: "TJ", countryNameEn: "Tajikistan", countryCallingCode: "992" },
  { countryCode: "TK", countryNameEn: "Tokelau", countryCallingCode: "690" },
  {
    countryCode: "TL",
    countryNameEn: "Timor-Leste",
    countryCallingCode: "670",
  },
  {
    countryCode: "TM",
    countryNameEn: "Turkmenistan",
    countryCallingCode: "993",
  },
  { countryCode: "TN", countryNameEn: "Tunisia", countryCallingCode: "216" },
  { countryCode: "TO", countryNameEn: "Tonga", countryCallingCode: "676" },
  { countryCode: "TR", countryNameEn: "Turkey", countryCallingCode: "90" },
  {
    countryCode: "TT",
    countryNameEn: "Trinidad and Tobago",
    countryCallingCode: "1868",
  },
  { countryCode: "TV", countryNameEn: "Tuvalu", countryCallingCode: "688" },
  { countryCode: "TW", countryNameEn: "Taiwan", countryCallingCode: "886" },
  { countryCode: "TZ", countryNameEn: "Tanzania", countryCallingCode: "255" },
  { countryCode: "UA", countryNameEn: "Ukraine", countryCallingCode: "380" },
  { countryCode: "UG", countryNameEn: "Uganda", countryCallingCode: "256" },
  {
    countryCode: "US",
    countryNameEn: "United States",
    countryCallingCode: "1",
  },
  { countryCode: "UY", countryNameEn: "Uruguay", countryCallingCode: "598" },
  { countryCode: "UZ", countryNameEn: "Uzbekistan", countryCallingCode: "998" },
  {
    countryCode: "VA",
    countryNameEn: "Vatican City",
    countryCallingCode: "379",
  },
  {
    countryCode: "VC",
    countryNameEn: "Saint Vincent and the Grenadines",
    countryCallingCode: "1784",
  },
  { countryCode: "VE", countryNameEn: "Venezuela", countryCallingCode: "58" },
  {
    countryCode: "VG",
    countryNameEn: "British Virgin Islands",
    countryCallingCode: "1284",
  },
  {
    countryCode: "VI",
    countryNameEn: "U.S. Virgin Islands",
    countryCallingCode: "1340",
  },
  { countryCode: "VN", countryNameEn: "Vietnam", countryCallingCode: "84" },
  { countryCode: "VU", countryNameEn: "Vanuatu", countryCallingCode: "678" },
  {
    countryCode: "WF",
    countryNameEn: "Wallis and Futuna",
    countryCallingCode: "681",
  },
  { countryCode: "WS", countryNameEn: "Samoa", countryCallingCode: "685" },
  { countryCode: "XK", countryNameEn: "Kosovo", countryCallingCode: "383" },
  { countryCode: "YE", countryNameEn: "Yemen", countryCallingCode: "967" },
  { countryCode: "YT", countryNameEn: "Mayotte", countryCallingCode: "262" },
  {
    countryCode: "ZA",
    countryNameEn: "South Africa",
    countryCallingCode: "27",
  },
  { countryCode: "ZM", countryNameEn: "Zambia", countryCallingCode: "260" },
  { countryCode: "ZW", countryNameEn: "Zimbabwe", countryCallingCode: "263" },
];

let cachedCountryCodes: CountryData[] | undefined;

export const getCountryCodesData = (): CountryData[] => {
  if (cachedCountryCodes && cachedCountryCodes.length > 0) {
    return cachedCountryCodes;
  }

  const filteredCountries = ALL_COUNTRY_CODES.filter(
    (country) => !BLACK_LISTED_COUNTRIES.has(country.countryCode)
  );

  const nonPriorityCountries = filteredCountries.filter(
    (country) => !PRIORITY_COUNTRIES.includes(country.countryCode)
  );

  const priorityCountries = PRIORITY_COUNTRIES.map((code) =>
    filteredCountries.find((country) => country.countryCode === code)
  ).filter(Boolean) as CountryData[];

  cachedCountryCodes = [...priorityCountries, ...nonPriorityCountries];

  return cachedCountryCodes;
};
